// ── Alphabet / keys ────────────────────────────────────────────────────────────
export const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
export const DEFAULT_NUM_KEYS = 5;

// ── Layout ─────────────────────────────────────────────────────────────────────
export const ORBIT_RADIUS = 170;
export const CONTAINER_SIZE = 420;
export const KEY_ANGLE_OFFSET = -15;
export const KEY_BUTTON_SIZE = 35;

// ── Egg SVG geometry ───────────────────────────────────────────────────────────
export const EGG_PATH =
  "M 100 15 C 122 15, 168 52, 172 108 C 176 160, 150 205, 100 205 C 50 205, 24 160, 28 108 C 32 52, 78 15, 100 15 Z";
export const EGG_TOP = 15;
export const EGG_BOTTOM = 205;
export const EGG_SVG_WIDTH = 260;
export const EGG_SVG_HEIGHT = 275;

// ── Paintbrush layout ──────────────────────────────────────────────────────────
export const BRUSH_TOP_Y = 10;
export const BRUSH_BOT_Y = 155;
export const BRUSH_X = -30;

// ── Particles ──────────────────────────────────────────────────────────────────
export const PARTICLE_COUNT = 12;
export const PARTICLE_MIN_SPEED = 0.8;
export const PARTICLE_SPEED_RANGE = 0.8;
export const PARTICLE_MIN_DURATION = 600;
export const PARTICLE_DURATION_RANGE = 300;
export const PARTICLE_MIN_DISTANCE = 60;
export const PARTICLE_DISTANCE_RANGE = 50;
export const PARTICLE_MIN_SIZE = 7;
export const PARTICLE_SIZE_RANGE = 6;
export const PARTICLE_GRAVITY = 40;

// ── Confetti ───────────────────────────────────────────────────────────────────
export const CONFETTI_COUNT = 60;

// ── Timing (ms) ────────────────────────────────────────────────────────────────
export const STROKE_DURATION_MS = 400;
export const KEY_BURST_MS = 400;
export const WIN_PRE_SHAKE_MS = 300;
export const WIN_SHAKE_DURATION_MS = 600;
export const WIN_DELAY_MS = 400;
export const INVALID_SHAKE_DURATION_MS = 500;

// ── Colors ─────────────────────────────────────────────────────────────────────
export const STRIPE_COLORS = [
  "#006B3C", // Deep Christmas green
  "#FFD700", // Gold
  "#FFFFFF", // Snow white
  "#B22222", // Firebrick red
  "#228B22", // Forest green
  "#C0392B", // Dark red
  "#F5F5DC", // Cream/ivory
  "#8B0000", // Deep red
  "#2E8B57", // Sea green
];

export const CONFETTI_COLORS = [
  "#FF3B3B",
  "#FFD600",
  "#FF8C00",
  "#00E5FF",
  "#76FF03",
  "#E040FB",
  "#FF4081",
];
